module.exports = __webpack_public_path__ + "images/Ki-logo-white_40.6cdcf717921827c3cf7be11af8e4e49e.png";